import { get, post, put, remove, handleClientError } from '../lib'

import { ConfigBody } from '../../types'

interface ResponseType {
  id: string
  name: string
  description: string
  user: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export const getConfig = async (
  sId: string,
  cId: string
): Promise<ResponseType> => {
  return get<ResponseType>({
    path: `/ipa/script/${sId}/config/${cId}`
  })
}

export const getConfigFile = async (
  sId: string,
  cId: string
): Promise<{ file: string }> => {
  return get<{ file: string }>({
    path: `/ipa/script/${sId}/config/${cId}/file`
  })
}

export const getConfigs = async (id: string): Promise<ResponseType[]> => {
  return get<ResponseType[]>({
    path: `/ipa/script/${id}/config`
  })
}

export const createConfig = async (
  id: string,
  body: ConfigBody
): Promise<ConfigBody> => {
  return post<ConfigBody, ConfigBody>({
    path: `/ipa/script/${id}/config`,
    body
  })
}

export const removeConfig = async (sId: string, cId: string): Promise<null> => {
  return remove({
    path: `/ipa/script/${sId}/config`,
    id: cId
  })
}

export const updateConfig = async (
  sId: string,
  cId: string,
  body: ConfigBody
): Promise<ConfigBody> => {
  return put<ConfigBody, ConfigBody>({
    path: `/ipa/script/${sId}/config/${cId}`,
    body
  })
}
